import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';

@Injectable()
export abstract class ApiQuery<R, V> extends Query<{ [key: string]: R }, V> {
	abstract readonly method: string;
}
